@if (visibilityState === 'visible') {
  <div
    class="boels-skeleton boels-skeleton--loading"
    [class.boels-skeleton--round-shape]="inputRoundShape"
    [ngStyle]="_inputStyle"
    [@fade]="visibilityState"
  >
    <span class="boels-skeleton__contents">
      <ng-content></ng-content>
    </span>
  </div>
}
